import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { InitializeProgramareComponent } from './initialize-programare/initialize-programare.component';
import { DetaliiProgramareComponent } from './detalii-programare/detalii-programare.component';
import { FinalizeProgramareComponent } from './finalize-programare/finalize-programare.component';
import { MaterialModule } from "src/app/material.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigationService } from './navigation.service';
import { NavbarProgramareComponent } from './navbar-programare/navbar-programare.component';
import { DisponibilitateProgramareComponent } from './disponibilitate-programare/disponibilitate-programare.component';
import { ContracteProgramariModule } from '../contracte-programari/contracte-programari.module';


const routes: Routes = [
    {
        path: '',
        component: InitializeProgramareComponent,
    },
    {
        path: 'detalii-programare',
        component: DetaliiProgramareComponent,
    },
    {
        path: 'finalizare-programare',
        component: FinalizeProgramareComponent,
    },
];

@NgModule({
    declarations: [
        InitializeProgramareComponent,
        DetaliiProgramareComponent,
        FinalizeProgramareComponent,
        NavbarProgramareComponent,
        DisponibilitateProgramareComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        ContracteProgramariModule,
    ],
    providers: [
        NavigationService
    ]
})
export class InregistrareProgramareModule { }
